import { onBeforeUnmount, ref } from 'vue';
import phxsgPromoBanner from '@sg/src/View/Components/Molecules/PromoBanner/phxsg-promo-banner.vue';
import GeoLoc from '@maison/components/GeoLoc';
import { emitter, COUNTRY_PROPOSITION_SHOULD_EXPAND } from '@phoenix/event-bus';
import createVueApp from '@phoenix/createVueApp';

const app = createVueApp({
  setup() {
    const isExpanded = ref(false);

    const onExpandBanner = () => {
      isExpanded.value = true;
    };

    const onClose = () => {
      localStorage.setItem(GeoLoc.CLOSED_BANNER_STORAGE_KEY, 'true');
    };

    emitter.on(COUNTRY_PROPOSITION_SHOULD_EXPAND, onExpandBanner);
    onBeforeUnmount(() => emitter.off(COUNTRY_PROPOSITION_SHOULD_EXPAND, onExpandBanner));

    return { onClose, expanded: isExpanded };
  },
});

app.component('PhxsgPromoBanner', phxsgPromoBanner);
app.mount('#phoenix-country-proposition-banner');
